var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"welcome-text"},[_vm._v("دۇردانە تور دەرسخانىسى ئارقا سۇپا باشقۇرۇش سېستىمىسىغا كىرگىنىڭىزنى قارشى ئالىمىز ")])])}]

export { render, staticRenderFns }